import React from "react";
import { BsMoon, BsSearch } from "react-icons/bs";
import Logo from "../../Assets/Images/logo.png";
import "./Header.scss";
import Slide from "react-reveal/Slide";
import { Link } from "react-router-dom";

const Header = () => {
  const handleDarkModeAlert = () => {
    alert("Dark Mode is under build");
  };
  return (
    <Slide top>
      <nav className="navbar fixed-top mt-3 mx-4 navbar-expand-lg navbar-light bg-transparent blurry">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img className="logo" src={Logo} alt="" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-3">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  to="/about"
                >
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/projects">
                  Projects
                </Link>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link disabled"
                  href="/"
                  tabindex="-1"
                  aria-disabled="true"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Posts is Coming..."
                >
                  Posts
                </a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
              </li>
            </ul>
            <form className="d-flex mb-2">
              <div className="input-group input-group-sm">
                <input
                  type="search"
                  id="floatingInput"
                  className="form-control custom-border"
                  placeholder="Search in Posts.."
                />
                <button
                  type="button"
                  className="btn btn-outline-primary border-0 rounded-circle"
                >
                  <BsSearch />
                </button>
                <button
                  type="button"
                  className="btn btn-primary border-0 rounded-circle"
                  onClick={handleDarkModeAlert}
                >
                  <BsMoon />
                </button>
              </div>
            </form>
          </div>
        </div>
      </nav>
    </Slide>
  );
};

export default Header;
